export const payType = {
    xm_air: {
        title: "厦门航空机场高铁定额消费券",
        platform: "qjf-line",
        type: "xm_air",
        banner: require("@/assets/images/xm_air/banner.png"),
        logo: require("@/assets/images/xm_air/logo.png"),
        steps: require("@/assets/images/xm_air/steps.png"),
        success: require("@/assets/images/xm_air/success.png"),
        coupon: require("@/assets/images/xm_air/coupon.png"),
        // qrcode: require("@/assets/images/xm_air/qrcode-banner.png"),
        account_placeholder: "请输入白鹭会员手机号",
        unit: "积分",
        view: {
            "--background-color": "#D4E6FA",//页面背景主色调
            "--recharge-success-bg-color": "radial-gradient(circle at bottom, #24BFE9 0%, #0278D2 65%)",//立即兑换按钮背景色
            "--recharge-fail-bg-color": "radial-gradient(circle at bottom, #AAAAAA 0%, #515151 65%)",//积分不足按钮背景色
            "--text-color": "#477FEB", //提示性文字颜色
            "--btn-color": "#477FEB", //普通按钮颜色
            "--recharge-title-color": "linear-gradient(90deg, rgba(42, 130, 228, 1) 0%, rgba(42, 130, 228, 0) 100%)", //兑换须知 标题颜色
            "--success-border-color": "#2C5FC6"
        },
        //使用规则:本券为一次性使用券，全场无门槛使用，出示短信内核销码即可使用，可叠加多张同时使用;
        rechargeText: [
            {
                title: "兑换须知",
                content: [
                    "积分兑换商品不提供报销凭证，一经兑换不可退换、转售、兑现、找零、拆分使用，可转赠给他人使用;",
                    "本券兑换成功后，核销码将发放到兑换时填写的手机号，请确保手机号填写正确，因手机号码填写错误造成的损失由会员本人承担;",
                    "机场消费代金券仅限机场合作门店使用，门店详情请<a style='color: #2A48A8;' href='https://platform.jifen360.com/qjf_store/?type=airline&business=xm_air'>点击查看</a>;",
                    "有效期:自兑换成功之日起90天内有效，请在有效期内使用，过期自动作废不可补发且积分不可退，若现场消费超出代金券面值，可现场兑换或使用其他方式支付差价;",
                    "使用规则:本券为一次性使用券，全场无门槛使用，出示短信内核销码即可使用，可叠加多张同时使用;",
                    "本平台仅是提供会员与商户之间的服务平台，如遇商品质量问题，请及时与商户联系;",
                    "如需帮助，请拨打服务热线:4000-360-195。"
                ]
            }
        ]
    }
}
